<crm-multi-select
  [placeholder]="placeholder"
  [options]="priorities"
  [(selectedItems)]="selectedPriorities"
  (selectedItemsChange)="selectedPrioritiesChange.emit($event)"
  [isTemplateCombined]="true"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [showClear]="showClear"
  dataKey="name"
  display="">
  <ng-template
    #selectedItemsTemplate
    let-priorities="items">
    <ng-container *ngFor="let priority of priorities; last as isLast">
      {{ priority?.value | helpdeskTaskPriorityName }}{{ isLast ? '' : ', ' }}
    </ng-container>
  </ng-template>
  <ng-template
    #itemTemplate
    let-priority="item"
    >{{ priority?.value | helpdeskTaskPriorityName }}</ng-template
  >
</crm-multi-select>
